import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ArrowForward from "@mui/icons-material/ArrowForward";
import AllInclusive from "@mui/icons-material/AllInclusive";
import Brightness5 from "@mui/icons-material/Brightness5";
import People from "@mui/icons-material/People";
import Icon from "@mui/material/Icon";
import useMediaQuery from "@mui/material/useMediaQuery";
import brand from "dan-api/dummy/brand";
import logo from "dan-images/logo.svg";
import { Input } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import ValidationUtil from "../Validation/ValidationUtil";
import Services from "../../Services/Services";
import iseapmu from "../../images/iseapmu.webp";
import Swal from "sweetalert2";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { createCanvas } from "canvas";
import useStyles from "../../components/Forms/user-jss";
import { userLogin, userRedirectLogin } from "../../Services/UserUtil";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import "./UserRegistration.css";
import UserRegistration from "./UserRegistration";

const LinkBtn = React.forwardRef(function LinkBtn(props, ref) {
  return <NavLink to={props.to} {...props} innerRef={ref} />;
});

const OTPBasedRegistration = (props) => {
  const formRef = useRef(null);
  const { classes, cx } = useStyles();
  const [showEmailMessage, setEmailShowMessage] = useState(false);
  const [tab, setTab] = useState(0);
  const [showInputField, setShowInputField] = useState(0);
  const [getURLReffCode, setCurrURLReffCode] = useState("");
  const [getCurrClientID, setCurrClientID] = useState("");
  const [getEmailOTPCode, setEmailOTPCode] = useState("");
  const [getEmailVerifyKey, setEmailVerifyKey] = useState("");
  const [emailOtpBtn, setEmailOtpBtn] = useState(false);
  const [emailIsValid, setEmailIsValid] = useState(false);
  const [getCaptchaString, setCaptchaString] = useState();
  const [getCaptchaId, setCaptchaId] = useState();
  const [getImageSrc, setImageSrc] = useState(null);
  const [getCaptchaKey, setCaptchaKey] = useState();
  const [getErrorMsg, setErrorMsg] = useState({});
  const [seconds, setSeconds] = useState(150);
  const [startTimer, setStartTimer] = useState(false);

  const { slideMode } = props;
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const { handleSubmit, pristine, submitting, deco } = props;
  const required = (value) => (value === null ? "Required" : undefined);
  const initialState = {
    fields: {},
    errors: {},
  };

  const [activeOtp, setActiveOtp] = useState(true);
  const [activePassword, setActivePassword] = useState(false);

  const [inputState, setInputState] = useState({
    referral: 0,
  });
  const { referral } = inputState;
  const [getUserInfoDetails, setUserInfoDetails] = useState(initialState);
  const [getOtpMessage, setOtpMessage] = useState();

  // useEffect(() => {
  //   const currURLReffCode = window.location.href.split("=")[1];

  //   setCurrURLReffCode(currURLReffCode);
  // }, []);
  const handleToggleInstruction = () => {
    setEmailShowMessage(!showEmailMessage);
  };

  useEffect(() => {
    if (startTimer && seconds > 0) {
      const interval = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds <= 1) {
            clearInterval(interval);
            setStartTimer(false); // Stop the timer
            return 0;
          }
          return prevSeconds - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [startTimer, seconds]);

  const handleClick = () => {
    setShowLoading(true);
    setShowStartTimer(true);
    setShowLoading(5); // Reset seconds to 5 for the new countdown
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  // console.log("seconds", seconds, "startTimer", startTimer);

  useEffect(() => {
    const url = new URL(window.location.href);
    const currURLReffCode = url.searchParams.get("referral_code");
    setCurrURLReffCode(currURLReffCode);
    const clientId = url.searchParams.get("client_id");
    setCurrClientID(clientId);

    // if (currURLReffCode || clientId) {
    //   console.log("Code:", currURLReffCode);
    //   console.log("Client ID:", clientId);
    // }
  }, []);

  const loginSubmit = () => {
    const bodyjson = {
      client: getCurrClientID || "ivp",
    };
    // userLogin();
    userRedirectLogin(bodyjson.client);
  };

  const handleChange = (e) => {
    let fields = getUserInfoDetails.fields;
    fields[e.target.name] = e.target.value;
    if (fields["email"]) {
      setOtpMessage(null);
    }
    setUserInfoDetails({ ...getUserInfoDetails, fields });
  };

  const handleChangeRefCode = (name) => (event) => {
    setInputState({
      ...inputState,
      [name]: event.target.checked ? 1 : 0,
    });
    setShowInputField(event.target.checked ? 1 : 0);
  };
  useEffect(() => {
    if (getURLReffCode) {
      let fields = getUserInfoDetails.fields;
      fields["referral_code"] = getURLReffCode;
      setUserInfoDetails({ ...getUserInfoDetails, fields });
      setInputState({
        ...inputState,
        referral: 1,
      });
      setShowInputField(1);
    }
  }, [getURLReffCode]);

  const onFirstNameChange = () => {
    let fields = getUserInfoDetails.fields;
    let errors = getUserInfoDetails.errors;
    if (!ValidationUtil.isCharacter(fields["first_name"])) {
      errors["first_name"] = "*Only alphabatic characters are allowed ";
    } else {
      delete errors["first_name"];
    }

    setUserInfoDetails({ ...getUserInfoDetails, errors });
  };

  const onLastNameChange = () => {
    let fields = getUserInfoDetails.fields;
    let errors = getUserInfoDetails.errors;
    if (!ValidationUtil.isCharacter(fields["last_name"])) {
      errors["last_name"] = "*Only alphabatic characters are allowed ";
    } else {
      delete errors["last_name"];
    }

    setUserInfoDetails({ ...getUserInfoDetails, errors });
  };
  const onEmailChange = () => {
    let fields = getUserInfoDetails.fields;
    let errors = getUserInfoDetails.errors;
    if (!ValidationUtil.isEmail(fields["email"])) {
      errors["email"] = "*Only Valid Email ID are Allowed ";
    } else {
      delete errors["email"];
    }

    setUserInfoDetails({ ...getUserInfoDetails, errors });
  };

  const onMobileChange = () => {
    let fields = getUserInfoDetails.fields;
    let errors = getUserInfoDetails.errors;
    if (
      !ValidationUtil.validContactNumberNoZero(fields["mobileno"]) ||
      !ValidationUtil.numberTest(fields["mobileno"])
    ) {
      errors["mobileno"] = "*Enter Valid Mobile Number ";
    } else if (!ValidationUtil.isContactNumber(fields["mobileno"])) {
      errors["mobileno"] = "*Only numbers are allowed ";
    } else {
      delete errors["mobileno"];
    }

    setUserInfoDetails({ ...getUserInfoDetails, errors });
  };

  const validate = () => {
    let fields = getUserInfoDetails.fields;
    let errors = {};
    let formIsValid = true;
    // console.log("inside validaet", !ValidationUtil);
    if (!ValidationUtil.isRequired(fields["email"])) {
      formIsValid = false;
      errors["email"] = "*Please enter Email";
    } else if (
      !ValidationUtil.validContactNumberNoZero(fields["mobileno"]) ||
      !ValidationUtil.isContactNumber(fields["mobileno"])
    ) {
      formIsValid = false;
      errors["mobileno"] = "*Please enter mobile number";
    } else if (!ValidationUtil.isValidEmail(fields["email"])) {
      formIsValid = false;
      errors["email"] = "*Only Valid Email ID are Allowed";
    }
    // else if (!ValidationUtil.isRequired(fields["otp_code"])) {
    //   formIsValid = false;
    //   errors["otp_code"] = "*Please enter Email OTP";
    // }

    setUserInfoDetails({ ...getUserInfoDetails, errors });

    return formIsValid;
  };

  const getEmailOTP = async (e) => {
    e.preventDefault();

    if (validate()) {
      const { email, mobileno } = getUserInfoDetails.fields;
      const bodyjson = {
        mail: email?.toLowerCase(),
        mobileno: mobileno,
        otp_secret_key:
          "B6X4PMZWWBBNMKWHKGHLI7YMBAMDKYYDLZQFYV5AWX5ASRWPDK4Q====",
      };
      const emailOTPSubmit = async () => {
        try {
          const response = await Services.email_otp_registration(bodyjson);
          if (response.status === 200) {
            // console.log("email otp", response);
            const email_otpCode = response.data?.data.code;
            const email_verifyKey = response.data?.data.verifyKey;

            setEmailOTPCode(email_otpCode);
            setEmailVerifyKey(email_verifyKey);
            setEmailOtpBtn(true);
            setSeconds(150);
            setStartTimer(true);
          }
        } catch (err) {
          // console.log("email otp err", err.response);
          if (err.response.status === 401) {
            const otpMessage = err.response.data?.message;
            // setOtpMessage(otpMessage);
            Swal.fire({
              title: "Warning",
              text: err.response.data.message,
              icon: "warning",
            });
          } else {
            Swal.fire({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        }
      };
      emailOTPSubmit();
    }
  };
  const handleSubmitGetOTP = (e) => {
    // console.log("called");
    e.preventDefault();
    getEmailOTP();
    setSeconds(150);
    setStartTimer(true);
  };

  const verifyEmailOtp = async (e) => {
    e.preventDefault();

    const { email, otp_code } = getUserInfoDetails.fields;
    const bodyjson = {
      mail: email,
      otp_secret_key:
        "B6X4PMZWWBBNMKWHKGHLI7YMBAMDKYYDLZQFYV5AWX5ASRWPDK4Q====",
      otp_code: otp_code,
      verifyKey: getEmailVerifyKey,
    };

    const verifyEmailOTPSubmit = async () => {
      try {
        const response = await Services.verify_email_otp_registartion(bodyjson);

        if (response.status === 200) {
          setEmailIsValid(true);
        }
      } catch (err) {
        Swal.fire({
          title: "Error",

          text:
            err.response.status === 500
              ? "Server not reachable"
              : err.response.data.errors,
          icon: "error",
        });
      }
    };
    verifyEmailOTPSubmit();
  };

  useEffect(() => {
    refreshCaptcha();
  }, []);

  const refreshCaptcha = (e) => {
    // e.preventDefault();
    // const getCaptchaRefresh = async () => {
    //   try {
    //     const res = await Services.getCaptchaForOtpReg();
    //     // console.log("captcha", res);
    //     if (res.status === 200) {
    //       // const captchaValue = res.data.data.captcha_image;
    //       const captchaValue = res.data.data.captcha_str;
    //       const captchaId = res.data.data.c_id;
    //       const captchaKey = res.data.data.key;
    //       // console.log("captha str", captchaKey);
    //       // const captchaImageUrl = `http://${captchaValue}?t=${Date.now()}`;
    //       // const captchaImageUrl = `http://${captchaValue}?t=${new Date().getTime()}`;
    //       // setCaptchaImg(captchaImageUrl);
    //       // const captchaStr = `${captchaValue} ${new Date().getTime()}`;
    //       const captchaStr = `${captchaValue} `;
    //       setCaptchaString(captchaStr);
    //       setCaptchaId(captchaId);
    //       setCaptchaKey(captchaKey);
    //     } else {
    //       Swal.fire({
    //         title: "Error",
    //         text: "captcha err",
    //         icon: "error",
    //       }).then(() => {
    //         refreshCaptcha();
    //       });
    //     }
    //   } catch (err) {
    //     // console.log("captcha err", err);
    //     const errorMsg = err.response?.data;
    //     setErrorMsg(errorMsg);
    //     let errorMessage = "";
    //     if (errorMsg) {
    //       Object.keys(errorMsg).forEach(([field, value]) => {
    //         errorMessage += errorMsg[field] + "\n";
    //       });

    //       if (err.response.status === 400) {
    //         Swal.fire({
    //           title: "Error",
    //           text: errorMessage,
    //           icon: "error",
    //         }).then(() => {
    //           refreshCaptcha();
    //         });
    //       } else if (err.response.data.status_code === 501) {
    //         Swal.fire({
    //           title: "Error",
    //           text: errorMessage,
    //           icon: "error",
    //         }).then(() => {
    //           refreshCaptcha();
    //         });
    //       } else {
    //         Swal.fire({
    //           title: "Error",
    //           text: errorMessage,
    //           icon: "error",
    //         }).then(() => {
    //           refreshCaptcha();
    //         });
    //       }
    //     }
    //   }
    // };
    const getCaptchaRefresh = async () => {
      try {
        const response = await Services.getCaptchaForOtpLoginRegistration();
        if (response.status === 200) {
          // console.log("captcha response", response);
          const captchaString = response.data?.captcha_image;
          setCaptchaString(captchaString);
          const mimeType = "image/png";
          const byteCharacters = atob(captchaString);
          const byteArrays = [];
          for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
          }
          const blob = new Blob([new Uint8Array(byteArrays)], {
            type: mimeType,
          });

          const imageUrl = URL.createObjectURL(blob);
          setImageSrc(imageUrl);
        }
      } catch (err) {
        // console.log("captcha err", err.response);
        const errorMsg = err.response?.data.detail;
        setErrorMsg(errorMsg);
        let errorMessage = "";
        if (errorMsg) {
          Object.keys(errorMsg).forEach(([field, value]) => {
            errorMessage += errorMsg[field] + "\n";
          });

          if (err.response.status === 400) {
            Swal.fire({
              title: "Error",
              text: errorMsg || errorMessage,
              icon: "error",
            }).then(() => {
              // refreshCaptcha();
              getCaptchaRefresh();
            });
          } else {
            Swal.fire({
              title: "Warning",
              text: errorMsg || errorMessage,
              icon: "warning",
            }).then(() => {
              // refreshCaptcha();
              getCaptchaRefresh();
            });
          }
        }
      }
    };
    getCaptchaRefresh();
    // formRef.current.reset();
  };

  const canvas = createCanvas(120, 50);
  const context = canvas.getContext("2d");

  context.fillStyle = "#f0f0f0";

  context.fillRect(0, 0, canvas.width, canvas.height);
  // Draw captcha text
  // context.font = "23px Arial";
  context.font = "bold  25px Comic Sans MS";
  context.fillStyle = "#000";
  context.textBaseline = "middle";
  context.fillText(getCaptchaString, 10, canvas.height / 2);

  const captchaDataURL = canvas.toDataURL("image/png");

  const formSubmit = (e) => {
    e.preventDefault();
    // if (validate()) {
    const {
      first_name,
      last_name,
      email,
      otp_code,
      mobileno,
      key,
      captcha,
      referral_code,
    } = getUserInfoDetails.fields;
    const bodyjson = {
      first_name,
      last_name,
      email,
      // otp_code,
      mobileno,
      referral_code,
      key: getCaptchaKey,
      otp_secret_key:
        "B6X4PMZWWBBNMKWHKGHLI7YMBAMDKYYDLZQFYV5AWX5ASRWPDK4Q====",
      otp_code: otp_code,
      verifyKey: getEmailVerifyKey,
      captcha,
      // mode: "ivp",
      mode: getCurrClientID || "ivp",
    };
    // console.log("otp body", bodyjson);

    const userRegistrationFunction = async (e) => {
      try {
        const response = await Services.userRegistrationByOtp(bodyjson);
        // console.log("resp resggg", response);
        if (response.status === 200) {
          // console.log("reh res", response);
          Swal.fire({
            title: "Success!",
            // text: err,
            // text: response.message,
            text: response.data.message || response.data.errors,
            icon: "success",
          }).then(function () {
            // userLogin();
            loginSubmit();
          });
          refreshCaptcha();
        } else {
          await Swal.fire({
            title: "Error",
            text: response.data.errors,
            icon: "error",
          }).then(() => {
            refreshCaptcha();
          });
        }
      } catch (err) {
        const errorMsg =
          err.response?.data.errors ||
          err.response?.data.detail ||
          err.response?.data;
        setErrorMsg(errorMsg);
        let errorMessage = "";

        // If errorMsg is an object, iterate over its fields
        if (typeof errorMsg === "object" && !Array.isArray(errorMsg)) {
          Object.keys(errorMsg).forEach((field) => {
            let readableField =
              field.replace(/_/g, " ").charAt(0).toUpperCase() +
              field.replace(/_/g, " ").slice(1);

            if (Array.isArray(errorMsg[field])) {
              errorMsg[field].forEach((message) => {
                // errorMessage += `${readableField}: ${message}\n`;
                errorMessage += `${message}\n`;
              });
            } else {
              // errorMessage += `${readableField}: ${errorMsg[field]}\n`;
              errorMessage += ` ${errorMsg[field]}\n`;
            }
          });
        } else {
          // If errorMsg is not an object, use it directly
          errorMessage = errorMsg;
        }

        if (err.response.status === 400) {
          Swal.fire({
            title: "Error",
            text: errorMessage || err.response.data.errors,
            icon: "error",
          }).then(() => {
            refreshCaptcha();
          });
        } else if (
          err.response.status === 501 ||
          errorMsg.status_code === 501
        ) {
          Swal.fire({
            title: "Error",
            text: err.response.data.errors || errorMessage,
            icon: "error",
          }).then(() => {
            refreshCaptcha();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: errorMessage || err.response.data.errors,
            icon: "error",
          }).then(() => {
            refreshCaptcha();
          });
        }
      }
    };
    userRegistrationFunction();
    // }
  };
  const handleOtpRegClick = () => {
    setActiveOtp(true);
    setActivePassword(false);
  };
  const handlePasswordClick = () => {
    setActiveOtp(false);
    setActivePassword(true);
  };
  const handleChangeTab = (event, value) => {
    setTab(value);
  };

  // console.log("email valid", emailIsValid);
  // console.log("getUserInfoDetails", getUserInfoDetails);
  return (
    <Fragment>
      {/* <div className="custom-shape-divider-bottom-1701770073">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
            className="shape-fill"
          ></path>
        </svg>
      </div> */}

      <div
        className="registerMainForm otpRegistrationForm"
        // className={cx(
        //   classes.banner,
        //   gradient ? classes.gradient : classes.solid,
        //   slideMode ? classes.out : classes.fit
        // )}
      >
        <div className={`registerForm1 ${classes.formRegisterOtp}`}>
          {!mdUp && (
            <NavLink
              to="/"
              className={`${cx(classes.brand, classes.outer)} text-white`}
            >
              <img src={iseapmu} alt="Isea Virtual Platform" />
              {/* {brand.name} */}
              ISEA Virtual Platform
            </NavLink>
          )}
          <div className={classes.borderPaperblock}>
            <Paper className={cx(classes.paperWrap, deco && classes.petal)}>
              <div className={` text-center ${classes.regHeaderText}`}>
                <Typography
                  variant="h5"
                  className={`  ${classes.title}`}
                  gutterBottom
                >
                  Please Register Here Once to Access Multiple ISEA Resources &
                  Services and Earn Reward Points & Certifications
                </Typography>
              </div>
              <div className={classes.mainRegisterationotpform}>
                {!mdDown && (
                  <div className={classes.topBar}>
                    <NavLink to="/" className={classes.brand}>
                      <img src={iseapmu} alt="Isea Virtual Platform" />
                      {/* {brand.name} */}
                      ISEA Virtual Platform
                    </NavLink>
                    <Button
                      size="small"
                      className={classes.buttonLink}
                      //   component={LinkBtn}
                      //   to="/login"
                      onClick={loginSubmit}
                    >
                      <Icon className={classes.icon}>arrow_forward</Icon>
                      Already have account ?
                    </Button>
                  </div>
                )}
                <Typography variant="h4" className={classes.title} gutterBottom>
                  Register
                </Typography>
                {/* <div className="d-flex align-items-center justify-content-center">
                  <div>
                    <Button
                      size="small"
                      className="px-3"
                      variant="contained"
                      onClick={handleOtpRegClick}
                    >
                      OTP
                    </Button>
                    <Button
                      size="small"
                      className="px-3 mx-2"
                      variant="contained"
                      onClick={handlePasswordClick}
                    >
                      PASSWAORD
                    </Button>
                  </div>
                </div> */}
                <Tabs
                  value={tab}
                  onChange={handleChangeTab}
                  indicatorColor="secondary"
                  textColor="secondary"
                  centered
                  className={`${classes.tab} mt-1 `}
                >
                  <Tab label="With Password" />
                  {/* <Tab label="With Email" /> */}
                </Tabs>
                {tab === 0 && <UserRegistration />}
                {tab === 1 && (
                  <section className={` OTP-form-Section ${classes.formWrap}`}>
                    <form ref={formRef} onSubmit={formSubmit}>
                      <div>
                        <div>
                          <FormControl
                            variant="standard"
                            className={`${classes.formControl} `}
                          >
                            {/* <label >Username</label> */}
                            <InputLabel
                              htmlFor="firstName"
                              className="required-label"
                            >
                              First name
                            </InputLabel>
                            <Input
                              name="first_name"
                              id="firstName"
                              placeholder="First Name"
                              required
                              // value={getUserInfoDetails.fields.first_name}
                              onChange={handleChange}
                              onBlur={onFirstNameChange}
                              autoComplete="off"
                              className={`  ${classes.field} ${
                                getUserInfoDetails.errors.first_name ===
                                undefined
                                  ? ""
                                  : "wrongValue"
                              } `}
                              pattern={"[a-zA-Zs , _\"''-]*"}
                            />
                            <span className="errorMsg text-left text-danger">
                              {getUserInfoDetails.errors["first_name"]}
                            </span>
                          </FormControl>
                        </div>
                        <div>
                          <FormControl
                            variant="standard"
                            className={classes.formControl}
                          >
                            {/* <label >Username</label> */}
                            <InputLabel
                              htmlFor="lastName"
                              className="required-label"
                            >
                              Last name
                            </InputLabel>
                            <Input
                              name="last_name"
                              label="Last name"
                              id="lastName"
                              placeholder="Last Name"
                              required
                              autoComplete="off"
                              // value={getUserInfoDetails.fields.last_name}
                              onChange={handleChange}
                              onBlur={onLastNameChange}
                              className={`${classes.field}   ${
                                getUserInfoDetails.errors.last_name ===
                                undefined
                                  ? ""
                                  : "wrongValue"
                              } `}
                              pattern={"[a-zA-Zs , _\"''-]*"}
                            />
                            <span className="errorMsg text-left text-danger">
                              {getUserInfoDetails.errors["last_name"]}
                            </span>
                          </FormControl>
                        </div>
                        <div className="form-inputs">
                          <FormControl
                            variant="standard"
                            className={`${classes.formControl} form-contol-input pr-0 `}
                          >
                            <InputLabel
                              htmlFor="email"
                              className="required-label "
                            >
                              Email
                            </InputLabel>
                            <Input
                              name="email"
                              label="Email"
                              type="email"
                              id="email"
                              placeholder="Email"
                              required
                              autoComplete="off"
                              className={emailIsValid ? "valid-email" : ""}
                              onChange={handleChange}
                              // onBlur={()=>onEmailChange()
                              //    handleToggleInstruction()}

                              onBlur={() => {
                                onEmailChange();
                                handleToggleInstruction();
                              }}
                              onFocus={() => handleToggleInstruction()}
                            />
                          </FormControl>
                          {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={getEmailOTP}
                            disabled={emailIsValid}
                            className={`${classes.generateOTP} `}
                          >
                            {!emailOtpBtn ? "Generate OTP" : "Resend"}
                          </Button> */}

                          {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={
                              !emailOtpBtn ? getEmailOTP : handleSubmitGetOTP
                            }
                            className={classes.generateOTP}
                            disabled={emailOtpBtn && seconds > 0}
                          >
                            {!emailOtpBtn
                              ? "Generate OTP"
                              : seconds > 0
                              ? formatTime(seconds)
                              : "Resend"}
                          </Button> */}
                          {/* ===================================================== */}
                          {/* <div className={classes.generateOTP}>
                            {!emailOtpBtn ? (
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={getEmailOTP}
                              >
                                Generate OTP
                              </Button>
                            ) : seconds > 0 ? (
                              <Button variant="contained" color="primary">
                                {formatTime(seconds)}
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={getEmailOTP}
                              >
                                Resend
                              </Button>
                            )}
                          </div> */}
                        </div>
                        <div className="text-left">
                          <span className="errorMsg text-left text-danger">
                            {getOtpMessage && getOtpMessage}
                          </span>
                        </div>

                        <div className="text-left">
                          <span className="errorMsg text-left text-danger">
                            {getUserInfoDetails.errors["email"]}
                          </span>
                        </div>
                        <div>
                          <FormControl
                            variant="standard"
                            className={classes.formControl}
                          >
                            {/* <label >Username</label> */}
                            <InputLabel
                              htmlFor="mobileNumber"
                              className="required-label"
                            >
                              Mobile Number
                            </InputLabel>
                            <Input
                              name="mobileno"
                              id="mobileNumber"
                              label="Mobile_Number"
                              placeholder="Mobile Number"
                              required
                              autoComplete="off"
                              onChange={handleChange}
                              // onBlur={onMobileChange}
                              onBlur={() => {
                                onMobileChange();
                                handleToggleInstruction();
                              }}
                              onFocus={() => handleToggleInstruction()}
                              className={`${classes.field} ${
                                getUserInfoDetails.errors.mobileno === undefined
                                  ? ""
                                  : "wrongValue"
                              }`}
                            />
                            <span className="errorMsg text-left text-danger">
                              {getUserInfoDetails.errors["mobileno"]}
                            </span>
                          </FormControl>
                        </div>

                        <div className="text-left">
                          <span className="errorMsg text-left text-danger">
                            {getOtpMessage && getOtpMessage}
                          </span>
                        </div>
                        {showEmailMessage && (
                          <div
                            className={` mt-2 ${classes.emailMsgInstruction}`}
                            role="alert"
                          >
                            <span>
                              * Validate your email and Mobile number using
                              generate OTP
                            </span>
                          </div>
                        )}
                        {/* <div>
                          {!!emailOtpBtn ? (
                            <div className="form-inputs">
                              <FormControl
                                variant="standard"
                                className={`${classes.formControl} form-contol-input pr-1 `}
                              >
                                <InputLabel
                                  htmlFor="email_otp"
                                  className="required-label "
                                >
                                  Email OTP
                                </InputLabel>
                                <Input
                                  name="otp_code"
                                  label="Email OTP"
                                  type="text"
                                  id="email_otp"
                                  placeholder="Email OTP"
                                  required
                                  autoComplete="off"
                                  onChange={handleChange}
                                />
                              </FormControl>
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={verifyEmailOtp}
                              >
                                Verify Email
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div> */}
                        {!!emailOtpBtn && (
                          <div className="form-inputs">
                            <FormControl
                              variant="standard"
                              className={`${classes.formControl} form-contol-input pr-0 `}
                            >
                              <InputLabel
                                htmlFor="email_otp"
                                className="required-label "
                              >
                                OTP
                              </InputLabel>
                              <Input
                                name="otp_code"
                                label="Email OTP"
                                type="text"
                                id="email_otp"
                                placeholder="Email OTP"
                                required
                                autoComplete="off"
                                onChange={handleChange}
                              />
                            </FormControl>
                          </div>
                        )}
                        <div className="otptextmessage">
                          {!!emailOtpBtn && (
                            <Typography
                              variant="p"
                              className={`${classes.title} otpMessage`}
                              gutterBottom
                            >
                              Kindly check your registered mobile number and
                              email id for OTP
                            </Typography>
                          )}
                        </div>
                        <div className={`${classes.generateOTP} mt-2`}>
                          {!emailOtpBtn ? (
                            <Button
                              variant="contained"
                              color="primary"
                              size="large"
                              onClick={getEmailOTP}
                            >
                              Generate OTP
                            </Button>
                          ) : seconds > 0 ? (
                            <Button variant="contained" color="primary">
                              {formatTime(seconds)}
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={getEmailOTP}
                              size="large"
                            >
                              Resend
                            </Button>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className={classes.refcodeStyle}>
                          <span>Do you have a referral code : </span>
                          <Checkbox
                            checked={referral === 1}
                            onChange={handleChangeRefCode("referral")}
                            value={inputState.referral}
                          />
                        </div>

                        {referral === 1 && showInputField === 1 && (
                          <div>
                            <FormControl
                              variant="standard"
                              className={` mb-1 ${classes.formControl}`}
                            >
                              <InputLabel htmlFor="referral_code">
                                Referral Code
                              </InputLabel>
                              <Input
                                name="referral_code"
                                id="referral_code"
                                placeholder="Enter Referral Code"
                                type="text"
                                value={getUserInfoDetails.fields.referral_code}
                                onChange={handleChange}
                                className={`${classes.field} ${
                                  getUserInfoDetails.errors.referral_code ===
                                  undefined
                                    ? ""
                                    : "wrongValue"
                                }`}
                              />
                              <span className="errorMsg text-left text-danger">
                                {getUserInfoDetails.errors["referral_code"]}
                              </span>
                            </FormControl>
                          </div>
                        )}
                      </div>
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="w-100">
                          <FormControl
                            variant="standard"
                            className={classes.formControl}
                          >
                            <InputLabel
                              htmlFor="captcha"
                              className="required-label"
                            >
                              Captcha Value
                            </InputLabel>
                            <Input
                              name="captcha"
                              id="captcha"
                              placeholder="Enter Captcha Value"
                              required
                              type="text"
                              // value={getUserInfoDetails.fields.captcha}
                              onChange={handleChange}
                              // onBlur={onConfirmPassword}
                              className={`${classes.field} ${
                                getUserInfoDetails.errors.captcha === undefined
                                  ? ""
                                  : "wrongValue"
                              }`}
                            />
                            <span className="errorMsg text-left text-danger">
                              {getUserInfoDetails.errors["captcha"]}
                            </span>
                          </FormControl>
                        </div>
                        <div className="mx-2 w-100">
                          {/* {captchaDataURL && (
                            <img src={captchaDataURL} alt={getCaptchaString} />
                          )} */}
                          {/* {getCaptchaString && <div> {getCaptchaString} </div>} */}
                          {getImageSrc && (
                            <img src={getImageSrc} alt="Captcha" />
                          )}
                        </div>
                        <div className={` mx-2 ${classes.captcha}`}>
                          <button type="button" onClick={refreshCaptcha}>
                            <i className="ion-ios-refresh"></i>
                          </button>
                        </div>
                      </div>

                      <div className={classes.btnArea}>
                        <Button
                          className="px-4"
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={!emailOtpBtn}
                        >
                          submit
                        </Button>
                      </div>
                    </form>
                  </section>
                )}
              </div>
            </Paper>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OTPBasedRegistration;
